import { Activity, ChartCandlestick, FileText, IdCard, Landmark, LayoutDashboard, Link2, LogOut, Map, Search, Shield, ShieldCheck } from 'lucide-react';
import { Link, NavLink, Outlet } from 'react-router-dom';
import MusicPlayer from './MusicPlayer.jsx';
import CommandPalette from './CommandPalette.jsx';
import { BRAND, logoUrl } from '../brand.js';

const links = [
  ['/', LayoutDashboard, 'Dispatch'], ['/lookup', Search, 'Records'], ['/map', Map, 'Live map'],
  ['/reports', FileText, 'Reports'], ['/civilian', Landmark, 'Civilian hub'], ['/market', ChartCandlestick, 'Exchange'], ['/personas', IdCard, 'Personas'], ['/linking', Link2, 'Account link']
];

export default function Shell({ user, onLogout }) {
  const cadUser = ['LEO','EMS','DISPATCH','ADMIN'].includes(user.role);
  const linkRequired = user.role !== 'ADMIN' && !user.reforger_uid;
  const visibleLinks = linkRequired
    ? [['/linking', Link2, 'Account link']]
    : cadUser ? [...links, ...(user.role === 'ADMIN' ? [['/admin', ShieldCheck, 'Admin center']] : [])] : links.filter(([to]) => ['/civilian','/market','/personas','/linking'].includes(to));
  return <div className="app-shell">
    <aside className="sidebar">
      <div className="brand"><img className="brand-logo" src={logoUrl()} alt={`${BRAND.network} logo`}/><div><strong>{BRAND.network.toUpperCase()}</strong><span>{BRAND.shortCity.toUpperCase()} · CAD / MDT</span></div></div>
      <nav>{visibleLinks.map(([to, Icon, label]) => <NavLink key={to} to={to} end={to === '/'} className={({isActive}) => isActive ? 'active' : ''}><Icon size={18}/><span>{label}</span></NavLink>)}</nav>
      <div className="sidebar-bottom"><div className="connection"><Activity size={14}/><span>Systems operational</span></div><button className="nav-button" onClick={onLogout}><LogOut size={18}/> Sign out</button></div>
    </aside>
    <div className="main-column">
      <header className="topbar"><div><span className="eyebrow">{BRAND.publicSafety.toUpperCase()}</span><strong>{BRAND.city} CAD</strong></div>{cadUser && <CommandPalette/>}<div className="user-chip"><Shield size={16}/><span>{user.discord_username}</span><b>{user.role}</b></div></header>
      {linkRequired&&<div className="global-link-banner"><Link2/><div><strong>Account link required before using the CAD</strong><span>Open Arma Reforger, copy the Shadow RP code shown in-game, then enter it here to unlock resident services.</span></div><Link to="/linking">Verify now</Link></div>}
      <main className="content"><Outlet /></main>
    </div>
    <MusicPlayer />
  </div>;
}
